import styles from "./WelCome.module.css";

const WelCome = () => {
  return <h1 className={styles.welComeBox}>환영합니다.</h1>;
};

export default WelCome;
